import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Includes/Navbar';
import Footer from './Includes/Footer';

const TermsOfService = () => {
  return (
    <>
        <Navbar /> 
        <div className="container">
        <main>
            <div className="term">
            <div className="term-container">
            <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                <h1>Termos de Serviço da QRCBR</h1>
              </div>
              <p>Ao acessar e realizar um pedido com o QRCBR, você confirma que está de acordo com os termos de serviço contidos nos Termos e Condições abaixo. 
                Estes termos se aplicam a todo o site e a qualquer e-mail ou outro tipo de comunicação entre você e o QRCBR.</p>
              <>
              <h3 id="toc_0">Termos Gerais</h3>
              <p>
                Ao acessar e realizar um pedido com o QRCBR, você confirma que está de
                acordo com os termos de serviço contidos nos Termos e Condições abaixo.
                Estes termos se aplicam a todo o site e a qualquer e-mail ou outro tipo de
                comunicação entre você e o QRCBR. Em nenhuma hipótese a equipe do QRCBR será
                responsável por danos diretos, indiretos, especiais, incidentais ou
                consequenciais, incluindo, mas não se limitando a, perda de dados ou lucros,
                resultantes do uso, ou da impossibilidade de uso, dos materiais neste site,
                mesmo que a equipe do QRCBR ou um representante autorizado tenha sido
                avisado sobre a possibilidade de tais danos. Se o seu uso de materiais deste
                site resultar na necessidade de manutenção, reparo ou correção de
                equipamentos ou dados, você assume quaisquer custos decorrentes. O QRCBR não
                será responsável por qualquer resultado que possa ocorrer durante o uso de
                nossos recursos. Reservamos o direito de alterar preços e revisar a política
                de uso dos recursos a qualquer momento.
              </p>
              <h3 id="toc_1">Licença</h3>
              <p>
                O QRCBR concede a você uma licença revogável, não exclusiva, intransferível
                e limitada para baixar, instalar e usar o site estritamente de acordo com os
                termos deste Acordo. Estes Termos e Condições são um contrato entre você e o
                QRCBR (referido nestes Termos e Condições como "QRCBR", "nós", "nos" ou
                "nosso"), o provedor do site QRCBR e dos serviços acessíveis a partir do
                site QRCBR (que são coletivamente referidos nestes Termos e Condições como o
                "Serviço QRCBR"). Você concorda em estar vinculado a estes Termos e
                Condições. Se você não concordar com estes Termos e Condições, por favor,
                não use o Serviço QRCBR. Nestes Termos e Condições, "você" se refere tanto a
                você como indivíduo quanto à entidade que você representa. Se você violar
                qualquer um destes Termos e Condições, reservamos o direito de cancelar sua
                conta ou bloquear o acesso à sua conta sem aviso prévio.
              </p>
              <h3 id="toc_2">Definições e Termos-Chave</h3>
              <p>
                Para ajudar a explicar as coisas de maneira mais clara nestes Termos e
                Condições, toda vez que qualquer um destes termos for mencionado, será
                estritamente definido como: - Cookie: pequena quantidade de dados gerados
                por um site e salvos pelo seu navegador. É usado para identificar o seu
                navegador, fornecer análises, lembrar informações sobre você, como suas
                preferências de idioma ou informações de login.
              </p>
              <p>
                <b>- Empresa: </b>quando esta política menciona "Empresa", "nós", "nos", ou
                "nosso", refere-se ao QRCBR, responsável pelas suas informações de acordo
                com estes Termos e Condições.
                <br />
                <b>- País: </b>onde o QRCBR ou os proprietários/fundadores do QRCBR estão
                baseados, neste caso, é o Brasil.
                <br />
                <b>- Dispositivo: </b>qualquer dispositivo conectado à internet, como um
                telefone, tablet, computador ou qualquer outro dispositivo que possa ser
                usado para acessar o QRCBR e utilizar os serviços.
                <br />
                <b>- Serviço: </b>refere-se ao serviço fornecido pelo QRCBR conforme
                descrito nos termos relativos (se disponíveis) e nesta plataforma.
                <br />
                <b>- Serviço de terceiros: </b>refere-se a anunciantes, patrocinadores de
                concursos, parceiros de promoções e marketing, e outros que fornecem nosso
                conteúdo ou cujos produtos ou serviços acreditamos que possam interessá-lo.
                <br />
                <b>- Site: </b>o site do QRCBR, acessível através do URL:
                https://www.qrcbr.com.br
                <br />
                <b>- Você: </b>uma pessoa ou entidade registrada no QRCBR para usar os
                Serviços.
              </p>
              <h3 id="toc_3">Restrições</h3>
              <p>
                Você concorda em não fazer e não permitirá que outros façam: Licenciar,
                vender, alugar, arrendar, ceder, distribuir, transmitir, hospedar,
                terceirizar, divulgar ou explorar comercialmente o site ou tornar a
                plataforma disponível para qualquer terceiro. Modificar, criar obras
                derivadas, desmontar, descriptografar, recompilar ou engenharia reversa de
                qualquer parte do site. Remover, alterar ou ocultar qualquer aviso de
                propriedade (incluindo qualquer aviso de direitos autorais ou marcas
                registradas) do QRCBR ou de seus afiliados, parceiros, fornecedores ou
                licenciadores do site.
              </p>
              <h3 id="toc_4">Política de Devolução e Reembolso</h3>
              <p>
                Obrigado por comprar no QRCBR. Apreciamos o fato de você gostar de comprar
                os produtos que criamos. Também queremos garantir que você tenha uma
                experiência satisfatória enquanto explora, avalia e adquire nossos produtos.
                Como em qualquer experiência de compra, existem termos e condições que se
                aplicam às transações no QRCBR. Serei breve como os nossos advogados
                permitem. O principal a ser lembrado é que, ao fazer um pedido ou realizar
                uma compra no QRCBR, você concorda com os termos junto à Política de
                Privacidade do QRCBR. Se, por qualquer motivo, você não estiver
                completamente satisfeito com qualquer produto ou serviço que fornecemos, não
                hesite em entrar em contato conosco e discutiremos quaisquer questões que
                você esteja enfrentando com nosso produto.
              </p>
              <h3 id="toc_5">Suas Sugestões</h3>
              <p>
                Qualquer feedback, comentários, ideias, melhorias ou sugestões
                (coletivamente, "Sugestões") fornecidas por você ao QRCBR com respeito ao
                site permanecerão sendo propriedade exclusiva do QRCBR. O QRCBR estará livre
                para usar, copiar, modificar, publicar ou redistribuir as Sugestões para
                qualquer propósito e de qualquer maneira, sem qualquer crédito ou
                compensação para você.
              </p>
              <h3 id="toc_6">Seu Consentimento</h3>
              <p>
                Atualizamos nossos Termos e Condições para fornecer total transparência
                sobre o que está sendo definido quando você visita nosso site e como isso
                está sendo utilizado. Ao usar nosso site, registrar uma conta ou fazer uma
                compra, você consente com nossos Termos e Condições.
              </p>
              <h3 id="toc_7">Links para outros Sites</h3>
              <p>
                Este Termo e Condição se aplica apenas aos Serviços. Os Serviços podem
                conter links para outros sites não operados ou controlados pelo QRCBR. Não
                somos responsáveis pelo conteúdo, precisão ou opiniões expressas nesses
                sites, e tais sites não são investigados, monitorados ou verificados quanto
                à precisão ou integridade por nós. Lembre-se de que, ao usar um link para
                sair dos Serviços para outro site, nossos Termos e Condições não se aplicam
                mais. Sua navegação e interação em qualquer outro site, incluindo aqueles
                que têm links em nossa plataforma, estão sujeitos às regras e políticas
                daquele site. Esses terceiros podem usar seus próprios cookies ou outros
                métodos para coletar informações sobre você.
              </p>
              <h3 id="toc_8">Cookies</h3>
              <p>
                O QRCBR usa "Cookies" para identificar as áreas do nosso site que você
                visitou. Um Cookie é um pequeno pedaço de dados armazenado no seu computador
                ou dispositivo móvel pelo seu navegador. Usamos Cookies para melhorar o
                desempenho e a funcionalidade do nosso site, mas não são essenciais para o
                seu uso. No entanto, sem esses cookies, algumas funcionalidades, como
                vídeos, podem não ficar disponíveis ou você precisará inserir seus dados de
                login toda vez que visitar o site, pois não poderíamos lembrar que você já
                havia feito login anteriormente. A maioria dos navegadores pode ser
                configurada para desabilitar o uso de Cookies. Contudo, se você desabilitar
                os Cookies, pode não conseguir acessar as funcionalidades do nosso site
                corretamente ou totalmente. Nunca colocamos Informações Pessoalmente
                Identificáveis em Cookies.
              </p>
              <h3 id="toc_9">Alterações de nossos Termos e Condições</h3>
              <p>
                Você reconhece e concorda que o QRCBR pode parar (permanente ou
                temporariamente) de fornecer o Serviço (ou qualquer funcionalidade dentro do
                Serviço) para você ou para os usuários em geral, a critério exclusivo do
                QRCBR, sem aviso prévio. Você pode parar de usar o Serviço a qualquer
                momento. Não é necessário informar especificamente ao QRCBR quando você
                parar de usar o Serviço. Você reconhece e concorda que, se o QRCBR desativar
                o acesso à sua conta, você poderá ser impedido de acessar o Serviço, os
                detalhes da sua conta ou quaisquer arquivos ou outros materiais contidos na
                sua conta. Se decidirmos alterar nossos Termos e Condições, publicaremos
                essas mudanças nesta página e/ou atualizaremos a data de modificação dos
                Termos e Condições abaixo.
              </p>
              <h3 id="toc_10">Modificações em Nosso Site</h3>
              <p>
                O QRCBR reserva-se o direito de modificar, suspender ou descontinuar,
                temporária ou permanentemente, o site ou qualquer serviço ao qual ele esteja
                conectado, com ou sem aviso prévio e sem responsabilidade para com você.
              </p>
              <h3 id="toc_11">Atualizações em Nosso Site</h3>
              <p>
                O QRCBR pode, de tempos em tempos, fornecer melhorias ou aprimoramentos nas
                funcionalidades do site, que podem incluir patches, correções de bugs,
                atualizações, upgrades e outras modificações ("Atualizações"). As
                Atualizações podem modificar ou excluir certas funcionalidades do site. Você
                concorda que o QRCBR não tem a obrigação de (i) fornecer qualquer
                Atualização ou (ii) continuar fornecendo ou habilitando qualquer
                funcionalidade ou característica específica do site para você. Você ainda
                concorda que todas as Atualizações serão (i) consideradas parte integrante
                do site e (ii) sujeitas aos termos e condições deste Acordo.
              </p>
              <h3 id="toc_12">Propriedade do Produto Final</h3>
              <p>Os dados e o IP dos códigos que você gera são de sua propriedade.</p>
              <h3 id="toc_13">Serviços de Terceiros</h3>
              <p>
                Podemos exibir, incluir ou disponibilizar conteúdo de terceiros (incluindo
                dados, informações, aplicativos e outros produtos ou serviços) ou fornecer
                links para sites ou serviços de terceiros ("Serviços de Terceiros"). Você
                reconhece e concorda que o QRCBR não será responsável por quaisquer Serviços
                de Terceiros, incluindo sua precisão, completude, pontualidade, validade,
                conformidade com direitos autorais, legalidade, decência, qualidade ou
                qualquer outro aspecto. O QRCBR não assume nem terá qualquer
                responsabilidade perante você ou qualquer outra pessoa ou entidade em
                relação aos Serviços de Terceiros. Os Serviços de Terceiros e os links para
                eles são fornecidos exclusivamente como conveniência para você, e você os
                acessa e usa inteiramente por sua conta e risco, estando sujeito aos termos
                e condições desses terceiros.
              </p>
              <h3 id="toc_14">Prazo e Rescisão</h3>
              <p>
                Este Acordo permanecerá em vigor até ser rescindido por você ou pelo QRCBR.
                O QRCBR pode, a seu critério exclusivo, a qualquer momento e por qualquer
                motivo ou sem motivo, suspender ou rescindir este Acordo com ou sem aviso
                prévio. Este Acordo será rescindido imediatamente, sem aviso prévio do
                QRCBR, caso você não cumpra qualquer disposição deste Acordo. Você também
                pode rescindir este Acordo excluindo o site e todas as cópias dele do seu
                computador. Após a rescisão deste Acordo, você deve cessar todo o uso do
                site e excluir todas as cópias do site do seu computador. A rescisão deste
                Acordo não limitará quaisquer direitos ou recursos do QRCBR previstos por
                lei ou equidade em caso de violação por você (durante o período deste
                Acordo) de qualquer uma das suas obrigações sob este Acordo.
              </p>
              <h3 id="toc_15">Aviso de Violação de Direitos Autorais</h3>
              <p>
                Se você é o proprietário de direitos autorais ou o agente de tal
                proprietário e acredita que qualquer material em nosso site constitua uma
                violação de seus direitos autorais, entre em contato conosco fornecendo as
                seguintes informações: (a) uma assinatura física ou eletrônica do
                proprietário dos direitos autorais ou de uma pessoa autorizada a agir em seu
                nome; (b) identificação do material que está sendo alegado como infrator;
                (c) suas informações de contato, incluindo seu endereço, número de telefone
                e e-mail; (d) uma declaração sua de que você tem a boa-fé de que o uso do
                material não é autorizado pelos proprietários dos direitos autorais; e (e)
                uma declaração de que as informações na notificação são precisas e, sob pena
                de perjúrio, você está autorizado a agir em nome do proprietário.
              </p>
              <h3 id="toc_16">Indenização</h3>
              <p>
                Você concorda em indenizar e isentar o QRCBR e seus pais, subsidiárias,
                afiliadas, diretores, funcionários, agentes, parceiros e licenciadores (se
                houver) de qualquer reclamação ou demanda, incluindo honorários advocatícios
                razoáveis, devido ou resultante de: (a) seu uso do site; (b) violação deste
                Acordo ou de qualquer lei ou regulamento; ou (c) violação de qualquer
                direito de um terceiro.
              </p>
              <h3 id="toc_17">Ausência de Garantias</h3>
              <p>
                O site é fornecido a você "COMO ESTÁ" e "COMO DISPONÍVEL", com todos os
                defeitos, sem garantia de qualquer tipo. Na máxima extensão permitida pela
                lei aplicável, o QRCBR, em seu nome e em nome de seus afiliados e seus
                respectivos licenciadores e prestadores de serviços, isenta expressamente
                todas as garantias, sejam expressas, implícitas, estatutárias ou de outra
                forma, com relação ao site, incluindo todas as garantias implícitas de
                comercialização, adequação para um propósito específico, titularidade e não
                violação, além de garantias que possam surgir de curso de negociação, curso
                de desempenho, uso ou prática comercial. Sem limitar o exposto, o QRCBR não
                oferece qualquer garantia ou compromisso, nem faz qualquer representação de
                que o site atenderá às suas necessidades, alcançará quaisquer resultados
                pretendidos, será compatível ou funcionará com qualquer outro software,
                sistemas ou serviços, operará sem interrupção, atenderá a qualquer padrão de
                desempenho ou confiabilidade ou será livre de erros, ou que quaisquer erros
                ou defeitos possam ou serão corrigidos. Sem limitar o exposto, nem o QRCBR
                nem qualquer fornecedor do QRCBR faz qualquer representação ou garantia de
                qualquer tipo, expressa ou implícita: (i) quanto à operação ou
                disponibilidade do site, ou das informações, conteúdo, materiais ou produtos
                nele incluídos; (ii) que o site estará ininterrupto ou livre de erros; (iii)
                quanto à precisão, confiabilidade ou atualidade de qualquer informação ou
                conteúdo fornecido por meio do site; ou (iv) que o site, seus servidores, o
                conteúdo ou e-mails enviados de ou em nome do QRCBR estão livres de vírus,
                scripts, cavalos de Troia, worms, malware, bombas-relógio ou outros
                componentes prejudiciais. Algumas jurisdições não permitem a exclusão ou
                limitação de garantias implícitas ou a limitação dos direitos legais
                aplicáveis do consumidor, então algumas ou todas as exclusões e limitações
                acima podem não se aplicar a você.
              </p>
              <h3 id="toc_18">Limitação de Responsabilidade</h3>
              <p>
                Não obstante quaisquer danos que você possa incorrer, a total
                responsabilidade do QRCBR e de seus fornecedores sob qualquer disposição
                deste Acordo e seu recurso exclusivo para todos os itens acima será limitada
                ao valor efetivamente pago por você pelo site. Na máxima extensão permitida
                pela lei aplicável, em nenhuma hipótese o QRCBR ou seus fornecedores serão
                responsáveis por quaisquer danos especiais, incidentais, indiretos ou
                consequenciais (incluindo, mas não se limitando a, danos por perda de
                lucros, perda de dados ou outras informações, interrupção de negócios,
                lesões pessoais, perda de privacidade resultante ou de qualquer forma
                relacionada ao uso ou à incapacidade de usar o site, software de terceiros
                e/ou hardware de terceiros usados com o site, ou de qualquer outra forma em
                conexão com qualquer disposição deste Acordo), mesmo que o QRCBR ou qualquer
                fornecedor tenha sido avisado da possibilidade de tais danos e mesmo que o
                remédio falhe em seu propósito essencial. Alguns estados/jurisdições não
                permitem a exclusão ou limitação de danos incidentais ou consequenciais,
                portanto, a limitação ou exclusão acima pode não se aplicar a você.
              </p>
              <h3 id="toc_19">Divisibilidade</h3>
              <p>
                Se qualquer disposição deste Acordo for considerada inaplicável ou inválida,
                tal disposição será alterada e interpretada para cumprir os objetivos dessa
                disposição na maior extensão possível sob a legislação aplicável, e as
                disposições restantes continuarão em pleno vigor e efeito. Este Acordo,
                juntamente com a Política de Privacidade e qualquer outro aviso legal
                publicado pelo QRCBR nos Serviços, constituirá o acordo integral entre você
                e o QRCBR sobre os Serviços. Se qualquer disposição deste Acordo for
                considerada inválida por um tribunal de jurisdição competente, a invalidez
                dessa disposição não afetará a validade das disposições restantes deste
                Acordo, que permanecerão em pleno vigor e efeito. Nenhuma renúncia de
                qualquer termo deste Acordo será considerada uma renúncia adicional ou
                contínua de tal termo ou de qualquer outro termo, e a falha do QRCBR em
                afirmar qualquer direito ou disposição sob este Acordo não constituirá uma
                renúncia de tal direito ou disposição. VOCÊ E O QRCBR CONCORDAM QUE QUALQUER
                CAUSA DE AÇÃO DECORRENTE OU RELACIONADA AOS SERVIÇOS DEVE SER INICIADA
                DENTRO DE UM (1) ANO APÓS O SURGIMENTO DA CAUSA DE AÇÃO. CASO CONTRÁRIO,
                ESSA CAUSA DE AÇÃO SERÁ BARRADA PERMANENTEMENTE.
              </p>
              <h3 id="toc_20">Renúncia</h3>
              <p>
                Exceto conforme disposto neste documento, a falha em exercer um direito ou
                exigir o cumprimento de uma obrigação sob este Acordo não afetará a
                capacidade de uma parte de exercer tal direito ou exigir tal cumprimento a
                qualquer momento após isso, nem a renúncia de uma violação constituirá
                renúncia de qualquer violação subsequente. A falha em exercer, e nenhum
                atraso em exercer, por qualquer das partes, qualquer direito ou qualquer
                poder sob este Acordo não será considerada uma renúncia desse direito ou
                poder. Nem qualquer exercício único ou parcial de qualquer direito ou poder
                sob este Acordo excluirá o exercício adicional desse ou de qualquer outro
                direito concedido neste documento. No caso de um conflito entre este Acordo
                e quaisquer termos de compra ou outros termos aplicáveis, os termos deste
                Acordo prevalecerão.
              </p>
              <h3 id="toc_21">Alterações a este Acordo</h3>
              <p>
                O QRCBR reserva-se o direito, a seu exclusivo critério, de modificar ou
                substituir este Acordo a qualquer momento. Se uma revisão for substancial,
                forneceremos um aviso de pelo menos 30 dias antes que os novos termos entrem
                em vigor. O que constitui uma mudança substancial será determinado a nosso
                exclusivo critério. Ao continuar acessando ou usando nosso site após a
                revisão dos termos, você concorda em estar vinculado pelos termos revisados.
                Se você não concordar com os novos termos, não estará mais autorizado a usar
                o QRCBR.
              </p>
              <h3 id="toc_22">Acordo Integral</h3>
              <p>
                Este Acordo constitui o acordo integral entre você e o QRCBR sobre o uso do
                site e substitui todos os acordos escritos ou orais anteriores e
                contemporâneos entre você e o QRCBR. Você pode estar sujeito a termos e
                condições adicionais que se aplicam quando você usar ou comprar outros
                serviços do QRCBR, os quais o QRCBR fornecerá a você no momento de tal uso
                ou compra.
              </p>
              <h3 id="toc_23">Atualizações dos Nossos Termos</h3>
              <p>
                Podemos alterar nosso Serviço e políticas, e podemos precisar fazer
                alterações a estes Termos para que eles reflitam com precisão nosso Serviço
                e políticas. A menos que seja exigido por lei, notificaremos você (por
                exemplo, através do nosso Serviço) antes de fazermos alterações a estes
                Termos e daremos a você a oportunidade de revisá-los antes que entrem em
                vigor. Então, se você continuar a usar o Serviço, estará vinculado aos
                Termos atualizados. Se você não quiser concordar com estes ou quaisquer
                Termos atualizados, poderá excluir sua conta.
              </p>
              <h3 id="toc_24">Propriedade Intelectual</h3>
              <p>
                O site e todo o seu conteúdo, recursos e funcionalidades (incluindo, mas não
                se limitando a todas as informações, software, textos, exibições, imagens,
                vídeos e áudios, bem como o design, seleção e disposição destes) são de
                propriedade do QRCBR, seus licenciadores ou outros fornecedores de tais
                materiais e estão protegidos por direitos autorais, marcas registradas,
                patentes, segredos comerciais e outras leis de propriedade intelectual ou
                direitos proprietários nacionais e internacionais. O material não pode ser
                copiado, modificado, reproduzido, baixado ou distribuído de qualquer forma,
                no todo ou em parte, sem a permissão expressa e por escrito do QRCBR, salvo
                e exceto conforme expressamente fornecido nestes Termos e Condições.
                Qualquer uso não autorizado do material é proibido.
              </p>
              <h3 id="toc_25">Acordo para Arbitragem</h3>
              <p>
                Esta seção se aplica a qualquer disputa, EXCETO QUANDO SE REFERE A
                RECLAMAÇÕES DE MEDIDAS INJUNTIVAS OU EQUITATIVAS RELACIONADAS AOS DIREITOS
                DE PROPRIEDADE INTELECTUAL SEUS OU DO QRCBR. O termo "disputa" significa
                qualquer disputa, ação ou outra controvérsia entre você e o QRCBR
                relacionada aos Serviços ou a este Acordo, seja por contrato, garantia, ato
                ilícito, estatuto, regulamento, ordenança ou qualquer outra base legal ou
                equitativa. "Disputa" será interpretado de maneira ampla, de acordo com o
                que for permitido pela lei.
              </p>
              <h3 id="toc_26">Notificação de Disputa</h3>
              <p>
                Em caso de disputa, você ou o QRCBR devem enviar à outra parte uma
                Notificação de Disputa, que é uma declaração escrita que expõe o nome,
                endereço e informações de contato da parte que a está enviando, os fatos que
                originam a disputa e o alívio solicitado. Você deve enviar qualquer
                Notificação de Disputa por e-mail para: contato@qrcbr.com.br. O QRCBR
                enviará qualquer Notificação de Disputa para você por correio, caso tenhamos
                seu endereço, ou, de outra forma, para seu e-mail. Você e o QRCBR tentarão
                resolver qualquer disputa por meio de negociação informal dentro de sessenta
                (60) dias após a data de envio da Notificação de Disputa. Após sessenta (60)
                dias, você ou o QRCBR podem iniciar a arbitragem.
              </p>
              <h3 id="toc_27">Arbitragem Vinculante</h3>
              <p>
                Se você e o QRCBR não resolverem a disputa por meio de negociação informal,
                qualquer outro esforço para resolver a disputa será conduzido exclusivamente
                por arbitragem vinculante, conforme descrito nesta seção. Você está abrindo
                mão do direito de litigar (ou participar como parte ou membro de classe)
                todas as disputas em tribunal perante um juiz ou júri. A disputa será
                resolvida por arbitragem vinculante de acordo com as regras de arbitragem
                comercial da Associação Americana de Arbitragem. Qualquer uma das partes
                pode buscar qualquer medida cautelar ou injuntiva provisória em qualquer
                tribunal de jurisdição competente, conforme necessário para proteger os
                direitos ou bens da parte enquanto a arbitragem não for concluída. Todos os
                custos legais, contábeis e outras taxas e despesas incorridas pela parte
                vencedora serão arcadas pela parte não vencedora.
              </p>
              <h3 id="toc_28">Envios e Privacidade</h3>
              <p>
                Caso você envie ou publique ideias, sugestões criativas, designs,
                fotografias, informações, anúncios, dados ou propostas, incluindo ideias
                para novos ou aprimorados produtos, serviços, recursos, tecnologias ou
                promoções, você concorda expressamente que tais envios serão automaticamente
                tratados como não confidenciais e não proprietários, e se tornarão de
                propriedade exclusiva do QRCBR, sem qualquer compensação ou crédito para
                você. O QRCBR e seus afiliados não terão obrigações em relação a tais envios
                ou publicações e poderão usar as ideias contidas nesses envios ou
                publicações para quaisquer fins em qualquer meio de forma perpétua,
                incluindo, mas não se limitando a, desenvolver, fabricar e comercializar
                produtos e serviços usando tais ideias.
              </p>
              <h3 id="toc_29">Promoções</h3>
              <p>
                O QRCBR pode, ocasionalmente, incluir concursos, promoções, sorteios ou
                outras atividades ("Promoções") que exijam que você envie material ou
                informações sobre você. Observe que todas as Promoções podem ser regidas por
                regras separadas que podem conter requisitos de elegibilidade específicos,
                como restrições de idade e localização geográfica. Você é responsável por
                ler todas as regras das Promoções para determinar se é elegível para
                participar. Caso participe de qualquer Promoção, você concorda em cumprir
                todas as Regras da Promoção. Termos e condições adicionais podem ser
                aplicáveis à compra de bens ou serviços no ou através dos Serviços, sendo
                esses termos parte deste Acordo por referência.
              </p>
              <h3 id="toc_30">Erros Tipográficos</h3>
              <p>
                Caso um produto e/ou serviço seja listado com um preço incorreto ou com
                informações erradas devido a erro tipográfico, reservamo-nos o direito de
                recusar ou cancelar qualquer pedido feito para o produto e/ou serviço
                listado com o preço incorreto. Reservamo-nos o direito de recusar ou
                cancelar qualquer pedido, independentemente de o pedido ter sido confirmado
                ou de seu cartão de crédito ter sido cobrado. Se o seu cartão de crédito já
                tiver sido cobrado pela compra e seu pedido for cancelado, emitiremos
                imediatamente um crédito para sua conta de cartão de crédito ou outra conta
                de pagamento no valor da cobrança.
              </p>
              <h3 id="toc_31">Disposições Gerais</h3>
              <p>
                Se, por qualquer motivo, um tribunal de jurisdição competente considerar
                qualquer disposição ou parte destes Termos e Condições inexequível, o
                restante destes Termos e Condições continuará em pleno vigor e efeito.
                Qualquer renúncia a qualquer disposição destes Termos e Condições só será
                válida se feita por escrito e assinada por um representante autorizado do
                QRCBR. O QRCBR terá direito a medidas injuntivas ou outras medidas
                equitativas (sem a obrigação de fornecer qualquer garantia ou caução) no
                caso de qualquer violação ou antecipação de violação por você. O QRCBR opera
                e controla o Serviço QRCBR a partir de sua base no Brasil. O Serviço não é
                destinado à distribuição ou uso por qualquer pessoa ou entidade em qualquer
                jurisdição ou país onde tal distribuição ou uso seja contrário à lei ou
                regulamento. Assim, aqueles que optam por acessar o Serviço QRCBR de outras
                localidades o fazem por sua própria iniciativa e são os únicos responsáveis
                por cumprir as leis locais, na medida em que estas sejam aplicáveis. Estes
                Termos e Condições (que incluem e incorporam a Política de Privacidade do
                QRCBR) contêm o entendimento completo e substituem todos os entendimentos
                anteriores entre você e o QRCBR em relação ao seu objeto, e não podem ser
                alterados ou modificados por você. Os títulos das seções usados neste Acordo
                são apenas para conveniência e não terão qualquer efeito legal.
              </p>
              <h3 id="toc_32">Isenção de Responsabilidade</h3>
              <p>
                O QRCBR não se responsabiliza por qualquer conteúdo, código ou qualquer
                outra imprecisão. O QRCBR não fornece garantias ou garantias de qualquer
                tipo. Em nenhuma circunstância o QRCBR será responsável por quaisquer danos
                especiais, diretos, indiretos, consequenciais ou incidentais, ou quaisquer
                outros danos, seja em uma ação contratual, por negligência ou outro delito
                civil, decorrentes ou relacionados ao uso do Serviço ou ao conteúdo do
                Serviço. A Empresa reserva-se o direito de fazer adições, exclusões ou
                modificações nos conteúdos do Serviço a qualquer momento, sem aviso prévio.
                O Serviço QRCBR e seus conteúdos são fornecidos "como estão" e "conforme
                disponíveis", sem qualquer garantia ou declaração de qualquer tipo, seja
                expressa ou implícita. O QRCBR atua como distribuidor e não como editor do
                conteúdo fornecido por terceiros; como tal, o QRCBR não exerce controle
                editorial sobre esse conteúdo e não oferece garantia ou declaração quanto à
                precisão, confiabilidade ou atualidade de qualquer informação, conteúdo,
                serviço ou mercadoria fornecida ou acessível através do Serviço QRCBR. Sem
                limitar o exposto, o QRCBR especificamente isenta-se de todas as garantias e
                declarações em qualquer conteúdo transmitido no ou em conexão com o Serviço
                QRCBR ou em sites que possam aparecer como links no Serviço QRCBR, ou nos
                produtos fornecidos como parte do, ou de outra forma em conexão com, o
                Serviço QRCBR, incluindo, sem limitação, quaisquer garantias de
                comerciabilidade, adequação para um propósito específico ou não violação de
                direitos de terceiros. Nenhum conselho oral ou informação escrita fornecida
                pelo QRCBR ou qualquer um de seus afiliados, funcionários, diretores,
                agentes ou similares criará qualquer garantia. Informações de preço e
                disponibilidade estão sujeitas a alterações sem aviso prévio. Sem limitar o
                exposto, o QRCBR não garante que o Serviço QRCBR será ininterrupto, livre de
                erros, pontual ou imune a corrupções.
              </p>
              <h3 id="toc_33">Formas de Contato</h3>
              <p>
                Não hesite em entrar em contato conosco caso haja qualquer dúvida:
                <br />
                <b>Através do e-mail: </b>
                <a href="mailto:contato@qrcbr.com.br?subject=Informações%20sobre%20os%20Termos%20de%20Serviço&body=Olá, gostaria de mais informações sobre os Termos de Serviço.">
                  contato@qrcbr.com.br
                </a>
                <br />
              </p>
            </>
              </div>
            </div>
        </main>
        <footer>
            <Link to="/" style={{ color: 'green', fontWeight: 'bold' }}>Voltar</Link>
        </footer>
        </div>
        <Footer />
    </>
  );
};

export default TermsOfService;